/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const partnersSectionStyles = {
  partnerSectionContainer: {
    marginTop: "4rem",
    textAlign: "center",
    padding: "2rem",
  },
  logoContainer: {
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "150px",
    maxHeight: "100px",
    width: "100%",
    height: "auto",
  },
  logo: {
    maxWidth: "100%",
    maxHeight: "100px",
  },
  gridItem: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  }),
};

export default partnersSectionStyles;
